import { render, staticRenderFns } from "./FontsTable.vue?vue&type=template&id=7073c8af&scoped=true&"
import script from "./FontsTable.vue?vue&type=script&lang=ts&"
export * from "./FontsTable.vue?vue&type=script&lang=ts&"
import style0 from "./FontsTable.vue?vue&type=style&index=0&id=7073c8af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073c8af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
